import React from "react";
import "./Footer.css";
import facebookIcon from "../assets/facebook-logo.svg";
import instagramIcon from "../assets/instagram-logo.svg";
// import yelpIcon from "../assets/yelp-logo.svg";

const Footer = () => (
    <footer className="footer">
        <p>
            <a href="tel:+14807965133" className="footer-link">
                <i className="fas fa-phone"></i> (480) 796-5133
            </a>
        </p>
        <p>
            <a href="mailto:solsticestudiosaz@gmail.com" className="footer-link">
                <i className="fas fa-envelope"></i> solsticestudiosaz@gmail.com
            </a>
        </p>
        <div className="social-media-icons">
            <a
                href="https://www.facebook.com/profile.php?id=100057505927578"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
            >
                <img src={facebookIcon} alt="Facebook" />
            </a>
            <a
                href="https://maps.app.goo.gl/ij2mMEPfKKyZPdHJA"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="instagram"
            >
                <img src={instagramIcon} alt="instagram" />
            </a>
        </div>
        <p className="footer-note">
            Designed and Built by <a href="https://verde-designs.com" target="_blank" rel="noopener noreferrer">Verde Designs.</a>
            <br />
            &copy; 2024 Solstice Studios AZ. All rights
            reserved.
        </p>
    </footer>
);

export default Footer;
